import * as API from "@/services/API";
import * as API2 from "@/services/API2";
export default {
  getDefA(Id) {
    return API.apiClient.get(`/charterdefa/${Id}`);
  },
  postDefA(Id, payload) {
    return API.apiClient.post(`/charterdefa/${Id}`, payload);
  },
  printDefA(Id) {
    return API2.apiClient.post(`/printcharterdefa/${Id}`);
  },
  printDefAen(Id) {
    return API2.apiClient.post(`/enprintcharterdefa/${Id}`);
  },
  getDefB(Id) {
    return API.apiClient.get(`/charterdefb/${Id}`);
  },
  postDefB(Id, payload) {
    return API.apiClient.post(`/charterdefb/${Id}`, payload);
  },
  printDefB(Id) {
    return API2.apiClient.post(`/printcharterdefb/${Id}`);
  },
  printDefBen(Id) {
    return API2.apiClient.post(`/enprintcharterdefb/${Id}`);
  },
  getDefC(Id) {
    return API.apiClient.get(`/charterdefc/${Id}`);
  },
  postDefC(Id, payload) {
    return API.apiClient.post(`/charterdefc/${Id}`, payload);
  },
  printDefC(Id) {
    return API2.apiClient.post(`/printcharterdefc/${Id}`);
  },
  printDefCen(Id) {
    return API2.apiClient.post(`/enprintcharterdefc/${Id}`);
  },
  getDefD(Id) {
    return API.apiClient.get(`/charterdefd/${Id}`);
  },
  postDefD(Id, payload) {
    return API.apiClient.post(`/charterdefd/${Id}`, payload);
  },
  printDefD(Id) {
    return API2.apiClient.post(`/printcharterdefd/${Id}`);
  },
  printDefDen(Id) {
    return API2.apiClient.post(`/enprintcharterdefd/${Id}`);
  },
  getDefE(Id) {
    return API.apiClient.get(`/charterdefe/${Id}`);
  },
  postDefE(Id, payload) {
    return API.apiClient.post(`/charterdefe/${Id}`, payload);
  },
  printDefE(Id) {
    return API2.apiClient.post(`/printcharterdefe/${Id}`);
  },
  printDefEen(Id) {
    return API2.apiClient.post(`/enprintcharterdefe/${Id}`);
  },
  getDefF(Id) {
    return API.apiClient.get(`/charterdeff/${Id}`);
  },
  postDefF(Id, payload) {
    return API.apiClient.post(`/charterdeff/${Id}`, payload);
  },
  printDefF(Id) {
    return API2.apiClient.post(`/printcharterdeff/${Id}`);
  },
  printDefFen(Id) {
    return API2.apiClient.post(`/enprintcharterdeff/${Id}`);
  },
  getDefG(Id) {
    return API.apiClient.get(`/charterdefg/${Id}`);
  },
  postDefG(Id, payload) {
    return API.apiClient.post(`/charterdefg/${Id}`, payload);
  },
  printDefG(Id) {
    return API2.apiClient.post(`/printcharterdefg/${Id}`);
  },
  printDefGen(Id) {
    return API2.apiClient.post(`/enprintcharterdefg/${Id}`);
  },
  getDefH(Id) {
    return API.apiClient.get(`/charterdefh/${Id}`);
  },
  postDefH(Id, payload) {
    return API.apiClient.post(`/charterdefh/${Id}`, payload);
  },
  printDefH(Id) {
    return API2.apiClient.post(`/printcharterdefh/${Id}`);
  },
  printDefHen(Id) {
    return API2.apiClient.post(`/enprintcharterdefh/${Id}`);
  },
  getDefI(Id) {
    return API.apiClient.get(`/charterdefi/${Id}`);
  },
  postDefI(Id, payload) {
    return API.apiClient.post(`/charterdefi/${Id}`, payload);
  },
  printDefI(Id) {
    return API2.apiClient.post(`/printcharterdefi/${Id}`);
  },
  printDefIen(Id) {
    return API2.apiClient.post(`/enprintcharterdefi/${Id}`);
  },
  getDefJ(Id) {
    return API.apiClient.get(`/charterdefj/${Id}`);
  },
  postDefJ(Id, payload) {
    return API.apiClient.post(`/charterdefj/${Id}`, payload);
  },
  printDefJ(Id) {
    return API2.apiClient.post(`/printcharterdefj/${Id}`);
  },
  printDefJen(Id) {
    return API2.apiClient.post(`/enprintcharterdefj/${Id}`);
  },
  getDefK(Id) {
    return API.apiClient.get(`/charterdefk/${Id}`);
  },
  postDefK(Id, payload) {
    return API.apiClient.post(`/charterdefk/${Id}`, payload);
  },
  printDefK(Id) {
    return API2.apiClient.post(`/printcharterdefk/${Id}`);
  },
  printDefKen(Id) {
    return API2.apiClient.post(`/enprintcharterdefk/${Id}`);
  },
  getDefL(Id) {
    return API.apiClient.get(`/charterdefl/${Id}`);
  },
  postDefL(Id, payload) {
    return API.apiClient.post(`/charterdefl/${Id}`, payload);
  },
  printDefL(Id) {
    return API2.apiClient.post(`/printcharterdefl/${Id}`);
  },
  printDefLen(Id) {
    return API2.apiClient.post(`/enprintcharterdefl/${Id}`);
  },
  getDefM(Id) {
    return API.apiClient.get(`/charterdefm/${Id}`);
  },
  postDefM(Id, payload) {
    return API.apiClient.post(`/charterdefm/${Id}`, payload);
  },
  printDefM(Id) {
    return API2.apiClient.post(`/printcharterdefm/${Id}`);
  },
  printDefMen(Id) {
    return API2.apiClient.post(`/enprintcharterdefm/${Id}`);
  },
  getDefN(Id) {
    return API.apiClient.get(`/charterdefn/${Id}`);
  },
  postDefN(Id, payload) {
    return API.apiClient.post(`/charterdefn/${Id}`, payload);
  },
  printDefN(Id) {
    return API2.apiClient.post(`/printcharterdefn/${Id}`);
  },
  printDefNen(Id) {
    return API2.apiClient.post(`/enprintcharterdefn/${Id}`);
  },
  getDefO(Id) {
    return API.apiClient.get(`/charterdefo/${Id}`);
  },
  postDefO(Id, payload) {
    return API.apiClient.post(`/charterdefo/${Id}`, payload);
  },
  printDefO(Id) {
    return API2.apiClient.post(`/printcharterdefo/${Id}`);
  },
  printDefOen(Id) {
    return API2.apiClient.post(`/enprintcharterdefo/${Id}`);
  },
};
